import * as z from "zod";

export const resolveEmailCorrection = {
  name: "resolveEmailCorrection" as const,
  input: z.object({
    id: z.string(),
    status: z.enum(["approved", "dismissed"]),
  }),
  output: z.object({}),
};
